const adjustExtraInfoVisibility = () => {
  document.querySelectorAll('.product-card__info').forEach((card) => {
    const extraInfo = card.querySelector('.product-card__extra-info');

    if (extraInfo) {
      const updateHeight = () => {
        const extraInfoHeight = extraInfo.scrollHeight;
        card.style.setProperty('--extra-info-height', `${extraInfoHeight}px`);
      };

      updateHeight();

      const mutationObserver = new MutationObserver(updateHeight);
      mutationObserver.observe(extraInfo, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      const resizeObserver = new ResizeObserver(updateHeight);
      resizeObserver.observe(extraInfo);
    }
  });
};

const setupHoverEffect = () => {
  document.querySelectorAll('.product-card').forEach((card) => {
    if (card) {
      card.addEventListener('mouseover', () => {
        card.classList.add('active');
      });

      card.addEventListener('mouseout', () => {
        card.classList.remove('active');
      });
    }
  });
};

const searchForFloatingControls = () => {
  const searchInterval = 1000;
  const maxDuration = 5000;
  let elapsedTime = 0;

  const intervalId = setInterval(() => {
    if (document.querySelector('.floating-controls-container')) {
      clearInterval(intervalId);
      adjustExtraInfoVisibility();
      setupHoverEffect();
    } else {
      elapsedTime += searchInterval;
      if (elapsedTime >= maxDuration) {
        clearInterval(intervalId);
      }
    }
  }, searchInterval);
};

document.addEventListener('DOMContentLoaded', () => {
  searchForFloatingControls();
  console.log('Scripts loaded');
});
